import {Stack, Typography} from "@mui/material";
import * as React from "react";
import {useNavigate} from "react-router-dom";

const ExtensionCard = (props) =>
{
    const navigate = useNavigate();

    function onView()
    {
        navigate("../extensions/" + props.entry.extensionUID);
    }

    return (
        <Stack direction="column" padding={1} spacing={1} alignItems="center" backgroundColor={'#141C21'} onClick={onView} borderRadius={3} sx={{width: 200, height: 200, cursor: "pointer"}}>
            <Stack direction="row" width="100%" alignItems="center" spacing={1}>
                <img src="/icons/extension.png" width={32} height={32}/>
                <Typography flexWrap="wrap">{props.entry.display} </Typography>
            </Stack>
            <Stack direction="row">
                <Typography variant="caption" padding={1}>{props.entry.extType}: {props.entry.extKey}, v{props.entry.extVersion}</Typography>
            </Stack>
            <Stack direction="row">
                <Typography variant="caption" padding={1}>{props.entry.extPublisher}</Typography>
            </Stack>
        </Stack>

    )
}
export default ExtensionCard;
